import React from "react";
import { Box, LinearProgress, AppBar, styled } from "@mui/material";

interface StyledAppBarProps {
  top?: number;
}

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: prop => prop !== "top",
})<StyledAppBarProps>(({ theme, top }) => ({
  backgroundColor: "transparent",
  "&.MuiAppBar-positionSticky": {
    [theme.breakpoints.up("lg")]: {
      top: top || 0,
    },
  },
}));

export interface AppLoaderProps {
  loading?: boolean;
  top?: number;
}

const AppLoader: React.FC<AppLoaderProps> = ({ loading, top }) => {
  return (
    <StyledAppBar position="sticky" component="div" top={top} {...({} as any)}>
      {loading ? (
        <Box width="100%" position="relative" height={4}>
          <LinearProgress />
        </Box>
      ) : (
        <Box width="100%" position="relative" style={{ background: "#fff" }} height={4}></Box>
      )}
    </StyledAppBar>
  );
};

export default AppLoader;
